import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import Button from '@material-ui/core/Button'
import { makeStyles, Theme } from '@material-ui/core/styles'
import clsx from 'clsx'
import React from 'react'

const useButtonStyles = makeStyles((theme: Theme) => ({
    workspaceButton: {
        borderRadius: 100,
        fontSize: pxToRem(12),
        backgroundColor: theme.palette.common.white,
        '&:hover': {
            backgroundColor: '#33AEA6',
            color: theme.palette.common.white,
            boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
        },
        '@media (max-width: 1024px)': {
            padding: theme.spacing(0.75, 1.25),
        },
    },
}))

export interface WorkspaceActionBarButtonWidgetProps {
    onClick?: VoidFunction
    disabled?: boolean
    className?: string
    label?: string
}

const WorkspaceActionBarButtonWidget: React.FC<WorkspaceActionBarButtonWidgetProps> = ({
    onClick,
    disabled,
    children,
    className,
    label
}) => {
    const classes = useButtonStyles()
    return (
        <Button
            variant="contained"
            color="default"
            disableElevation
            className={clsx(className, classes.workspaceButton)}
            onClick={onClick}
            disabled={disabled}
            aria-label={label}
            data-testid={label ? `actionBarButton-${label.replace(/ /g, '')}` : null}
        >
            {children}
        </Button>
    )
}

export default WorkspaceActionBarButtonWidget
